// (Dots + Fade + Desktop-Pfeile + antippbare Dots + Auto-Scroll zum aktiven Chip)
// Fix 15.07.2026: can-left/can-right (Scroll-Pfeile) zusaetzlich nach Font-Load und
// window.load neu berechnen. Vorher war der Pfeil beim Wechsel der Unterkategorie weg,
// weil die Erst-Messung noch mit dem Fallback-Font lief (Zeile passte knapp) und nach
// dem Swap auf Inter kein scroll/resize mehr feuerte -> Overflow blieb unerkannt.
(function(){
  var mq=window.matchMedia('(max-width:749px)');
  document.querySelectorAll('.cat-nav').forEach(function(nav){
    var row=nav.querySelector('.cat-nav__row'),
        dw=nav.querySelector('.cat-nav__dots'),
        aL=nav.querySelector('.cat-nav__arrow--left'),
        aR=nav.querySelector('.cat-nav__arrow--right'),
        DOT=4,dots=[],touched=false;
    if(dw){for(var i=0;i<DOT;i++){var s=document.createElement('span');dw.appendChild(s);dots.push(s);}}
    function up(){
      var max=row.scrollWidth-row.clientWidth,left=row.scrollLeft,more=max>1&&Math.ceil(left)<max;
      nav.classList.toggle('has-overflow',more);
      nav.classList.toggle('can-left',left>4);
      nav.classList.toggle('can-right',more);
      if(dw){var f=max>0?left/max:0,idx=Math.min(DOT-1,Math.round(f*(DOT-1)));
        dots.forEach(function(d,i){d.classList.toggle('is-active',i===idx);});
        dw.style.display=(max>1&&mq.matches)?'flex':'none';}
    }
    // aktiven Chip in die Reihe zentrieren (nur die Reihe, nicht die Seite)
    function centerActive(){
      var act=row.querySelector('.cat-chip.is-active, .cat-chip[aria-current="page"]');
      if(act){row.scrollLeft=Math.max(0,act.offsetLeft-(row.clientWidth-act.offsetWidth)/2);}
    }
    function step(dir){row.scrollBy({left:dir*Math.max(200,row.clientWidth*0.7),behavior:'smooth'});}
    if(aL)aL.addEventListener('click',function(){step(-1);});
    if(aR)aR.addEventListener('click',function(){step(1);});
    dots.forEach(function(d,i){d.addEventListener('click',function(){
      var max=row.scrollWidth-row.clientWidth;row.scrollTo({left:max*(i/(DOT-1)),behavior:'smooth'});});});
    // merkt sich, ob der Nutzer selbst gescrollt hat -> dann nicht mehr auto-zentrieren
    ['wheel','touchstart','pointerdown','keydown'].forEach(function(ev){
      row.addEventListener(ev,function(){touched=true;},{passive:true});});
    row.addEventListener('scroll',up,{passive:true});
    window.addEventListener('resize',up);
    // Erst-Setup
    centerActive();up();
    // Nach vollstaendigem Layout / Font-Swap neu vermessen (behebt den Pfeil-Race)
    window.addEventListener('load',function(){if(!touched)centerActive();up();});
    if(document.fonts&&document.fonts.ready){
      document.fonts.ready.then(function(){if(!touched)centerActive();up();});
    }
  });
})();
